import { IRootState } from '../../../store'
import { IAdditionalAssessmentsState } from '../store/additionalAssessments.types'

export const getAdditionalAssessmentsSelector = (state: IRootState): IAdditionalAssessmentsState =>
  state.additionalAssessments
